/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable security/detect-object-injection */

import React, {
    useCallback, useEffect
} from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { PremierConstants } from 'premier-constant-service';
import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import presentationMetadata from "gw-capability-gateway-quoteandbind-PremierSR-react/config/PremierSR-wizard-config.json5";
import metadata from './DronePage.metadata.json5';
import styles from './DronePage.module.scss';
import ProductCoverageSelectionComponent from '../../components/Drone/ProductCoverageSelection/ProductCoverageSelectionComponent';
import RiskInformationComponent from '../../components/Drone/RiskInformation/RiskInformationComponent';
import DronesActivitiesComponent from '../../components/Drone/DronesActivities/DronesActivitiesComponent';
import DroneInformationComponent from '../../components/Drone/DroneInformation/DroneInformationComponent';
import UnderwritingInformationComponent from '../../components/Drone/UnderwritingInformation/UnderwritingInformationComponent';

function DronePage(props) {

    const { wizardData: submissionVM, updateWizardData, steps, changeNextSteps } = props;
    const { updateSubmission } = useUpdateSubmissionServices();
    const liabilitySteps = _.filter(_.get(presentationMetadata, [`${submissionVM.value.baseData.productCode}.default.wizard`, 'steps']), (wizardStep) => wizardStep.id.includes('liabilityCoverages'))
    const propertySteps = _.filter(_.get(presentationMetadata, [`${submissionVM.value.baseData.productCode}.default.wizard`, 'steps']), (wizardStep) => wizardStep.id.includes('propertyCoverages'))
    const { lineName } = PremierConstants;

    const {
        onValidate,
        initialValidation
    } = useValidation('DronePage');

    useEffect(() => {

    }, []);

const onNext = useCallback(
        async () => {

            const liaCov = _.get(submissionVM.value, 'lobData.spoAndRecLine.coverables.droneCoverable.productCoverageSelection.liaCovFie');
            const proCov = _.get(submissionVM.value, 'lobData.spoAndRecLine.coverables.droneCoverable.productCoverageSelection.proFie');
            const isLiabilityCoverageSelected = !_.isUndefined(liaCov) && liaCov;
            const isProductCoverageSelected = !_.isUndefined(proCov) && proCov;

            if (isLiabilityCoverageSelected && isProductCoverageSelected) {
                let newSteps = steps;

                const droneIndex = steps.findIndex((step) => step.id === "off_DroUnmAir");

                const liabilityIndex = steps.findIndex((step) => step.id === "liabilityCoverages");

                if(liabilityIndex < 0) { 
                    steps.splice(droneIndex + 1, 0, liabilitySteps[0]);
                }

                const propertyIndex = steps.findIndex((step) => step.id === "propertyCoverages");

                if(propertyIndex < 0) { 
                    steps.splice(droneIndex + 2, 0, propertySteps[0]);
                }

                newSteps = steps.slice(droneIndex + 1);

                changeNextSteps(newSteps);

            } else if (isLiabilityCoverageSelected) {
                let newSteps = steps;

                const droneIndex = steps.findIndex((step) => step.id === "off_DroUnmAir");

                const liabilityIndex = steps.findIndex((step) => step.id === "liabilityCoverages");

                if(liabilityIndex < 0) { 
                    steps.splice(droneIndex + 1, 0, liabilitySteps[0]);
                }

                const propertyIndex = steps.findIndex((step) => step.id === "propertyCoverages");

                if(propertyIndex > 0) { 
                    steps.splice(propertyIndex, 1); 
                }

                newSteps = steps.slice(droneIndex + 1);

                changeNextSteps(newSteps);
            } else {
                let newSteps = steps;

                const liabilityIndex = steps.findIndex((step) => step.id === "liabilityCoverages");

                if(liabilityIndex >= 0) { 
                    steps.splice(liabilityIndex, 1); 
                }

                const propertyIndex = steps.findIndex((step) => step.id === "propertyCoverages");

                if(propertyIndex >= 0) { 
                    steps.splice(propertyIndex, 1); 
                }

                const riskAnalysisIndex = steps.findIndex((step) => step.id === "riskAnalysis");

                newSteps = steps.slice(riskAnalysisIndex);

                changeNextSteps(newSteps);
            }

            const { productCode } = submissionVM.value.baseData;
            const lobLineName = lineName[productCode];

            submissionVM.value = await updateSubmission(lobLineName, 'DronePage', submissionVM);

            return submissionVM;
        },
        [submissionVM, updateSubmission]
    );

    const onSave = useCallback(
        async () => {
            const subVMCopy = _.clone(submissionVM)
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');

            validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.spoAndRecLine.coverables.droneCoverable.value, ' ')

            const lobLineName = productCode ? lineName[productCode] : '';

            await updateSubmission(lobLineName, 'DronePage', subVMCopy);
                            
            return submissionVM;
        },
        [lineName, submissionVM, updateSubmission]
    );

    const overrideProps = {
        productCoverageSelectionComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.spoAndRecLine.coverables.droneCoverable.productCoverageSelection"
        },
        riskInformationComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.spoAndRecLine.coverables.droneCoverable.riskInformation"
        },
        droneInformationComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.spoAndRecLine.coverables.droneCoverable.droneInformation"
        },
        dronesActivitiesComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.spoAndRecLine.coverables.droneCoverable.dronesActivities"
        },
        underwritingInformationComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.spoAndRecLine.coverables.droneCoverable.underwritingInformation"
        }
    }

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            productCoverageSelectionComponent: ProductCoverageSelectionComponent,
            riskInformationComponent: RiskInformationComponent,
            droneInformationComponent: DroneInformationComponent,
            dronesActivitiesComponent: DronesActivitiesComponent,
            underwritingInformationComponent: UnderwritingInformationComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        [metadata.pageContent, submissionVM, overrideProps]
    );

    const isDisableNext = () => !_.isUndefined(submissionVM.lobData)
        && (!submissionVM.lobData.spoAndRecLine.coverables.droneCoverable.aspects.subtreeValid)

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

DronePage.propTypes = wizardProps;
export default withRouter(DronePage);
